import React, { useEffect } from 'react';

/**
 * Pick which month-year bucket to remove a state from (annual/decennial).
 */
const RemoveSightingModal = ({ isOpen, stateLabel, months, onClose, onSelectMonth }) => {
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="remove-sighting-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="remove-sighting-title"
      onClick={onClose}
    >
      <div
        className="remove-sighting-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="remove-sighting-modal__accent" aria-hidden="true" />
        <div className="remove-sighting-modal__inner">
          <h2 id="remove-sighting-title" className="remove-sighting-modal__title">
            Which month to remove?
          </h2>
          <p className="remove-sighting-modal__subtitle">
            {stateLabel ? (
              <>
                Remove <strong className="remove-sighting-modal__state">{stateLabel}</strong> from one of these months:
              </>
            ) : (
              <>Pick a month to remove this plate from:</>
            )}
          </p>
          <ul className="remove-sighting-modal__list">
            {months.map((m) => (
              <li key={m}>
                <button
                  type="button"
                  className="remove-sighting-modal__month-btn"
                  onClick={() => onSelectMonth(m)}
                >
                  <span className="remove-sighting-modal__month-text">{m}</span>
                  <span className="remove-sighting-modal__month-arrow" aria-hidden="true">
                    →
                  </span>
                </button>
              </li>
            ))}
          </ul>
          <button type="button" className="remove-sighting-modal__cancel" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default RemoveSightingModal;
